/* eslint-disable import/order */
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { peopleProfilesEntrypoint } from '@jira/spa-apps__people-profiles/src/peopleProfilesEntrypoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { layoutWithCondition } from '@jira/platform__layouts-route-layout/src/utils/layout-with-condition/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { peopleProfilesRoute } from '@jira/router-routes__people-profiles-routes/src/peopleProfilesRoute.tsx';
import { rightSidebarsLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';

const peopleProfilesPageEntrypoint = createPageEntryPoint({
	main: peopleProfilesEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const peopleProfilesRouteEntry: Route = createEntry(peopleProfilesRoute, () => ({
	group: 'people-profiles',

	layout: layoutWithCondition(
		() => expValEquals('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'),
		rightSidebarsLayout,
		globalLayout,
	),

	navigation: {
		menuId: MenuIdPeople,
	},

	resources: [...getNavigationResources(), getConsolidationStateResource()],
	ufoName: 'people-profiles',
	entryPoint: () => peopleProfilesPageEntrypoint,
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
